const config = {
  SERVER_URL: process.env.REACT_APP_SERVER_URL,
  NTFY_ADS_TOPIC: process.env.REACT_APP_NTFY_ADS_TOPIC,
  NTFY_AUTH: process.env.REACT_APP_NTFY_AUTH,
  STRIPE_ID: process.env.REACT_APP_STRIPE_ID,
};

export default config;
